import { SchedulesSearchConditionBasicType } from "../../../models/list"

const SCHEDULES_BASIC_SEARCH_INITIAL_VALUES: SchedulesSearchConditionBasicType =
  {
    arrivalCity: "",
    arrivalCityCode: "",
    arrivalDateTimeDate: "",
    bumonCd: "",
    countryToTravel: [],
    departureDateTimeDate: "",
    departureFlightNumber: "",
    dispatchType: "",
    dispatchTypeDetail: "",
    fullName: "",
    lodgingName: "",
    projectName: "",
    transitSearchType: "0",
    travelPurposeId: "",
    travelerId: "",
  }

export const InitialValues = {
  SCHEDULES_BASIC_SEARCH_INITIAL_VALUES,
}
